import { useEffect, useState } from "react";
import {
    Breadcrumb,
    Card,
    Col,
    Container,
    Row,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import { Devices } from "../../api/Devices";
import AppLoader from "../../components/AppLoader";
import { useToasts } from "../../contexts/toasts";
import { Device } from "../../models/Device";

export default function DeviceDetail() {
    const { t } = useTranslation();
    const { id } = useParams();

    const [device, setDevice] = useState<Device | null>();
    const { showToast } = useToasts();

    useEffect(() => {
        initDevice();
        // eslint-disable-next-line
    }, []);

    const initDevice = () => {
        Devices.getDevice(id!).then(
            ({ data: device }) => {
                setDevice(device);
            },
            (err) => {
                const message = err.response?.data?.message || err.message;
                const status = err.response?.status;
                showToast!(
                    "device-error",
                    message,
                    `Device Error ${status ? `(${status})` : ""}`,
                    "danger"
                );
            }
        );
    };

    const renderCardContent = () => {
        return (
            <>
                <Card.Body className="">
                    <Row>
                        <Col>
                            <div className="d-flex align-items-center mb-2">
                                <Col md={4}>
                                    <h6 className="mb-0">Device ID</h6>
                                </Col>
                                <Col md={8}>
                                    <p className="mb-0">{device!.id}</p>
                                </Col>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="d-flex align-items-center mb-2">
                                <Col md={4}>
                                    <h6 className="mb-0">Device Device type</h6>
                                </Col>
                                <Col md={8}>
                                    <p className="mb-0">{device!.deviceType.name}</p>
                                </Col>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="d-flex align-items-center mb-2">
                                <Col md={4}>
                                    <h6 className="mb-0">Device Label</h6>
                                </Col>
                                <Col md={8}>
                                    <p className="mb-0">{device!.label}</p>
                                </Col>
                            </div>

                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="d-flex align-items-center mb-2">
                                <Col md={4}>
                                    <h6 className="mb-0">Device tenant</h6>
                                </Col>
                                <Col md={8}>
                                    <p className="mb-0">{device!.organization?.name}</p>
                                </Col>
                            </div>

                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="d-flex align-items-center mb-2">
                                <Col md={4}>
                                    <h6 className="mb-0">Device status</h6>
                                </Col>
                                <Col md={8}>
                                    <p className="mb-0">{device!.status}</p>
                                </Col>
                            </div>

                        </Col>
                    </Row>
                </Card.Body>
            </>
        );
    };

    const renderAsyncContent = () => {
        return device ? (
            renderCardContent()
        ) : (
            <div className="d-flex py-3 justify-content-center">
                <AppLoader size={150} />
            </div>
        );
    };

    return (
        <Container>
            <Breadcrumb>
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: `/devices` }}>
                    {t("pages.devices")}
                </Breadcrumb.Item>
                <Breadcrumb.Item active>
                    {device?.id}
                </Breadcrumb.Item>
            </Breadcrumb>

            <Card>{renderAsyncContent()}</Card>
        </Container>
    );
}
